export default function ({ store, redirect }) {
  if (store.$auth.$state.user.user_role !== 2) {
    return redirect("/dashboard");
  }
}
